import Reveal from "./Reveal";
import Eyebrow from "./Eyebrow";

const u = (id, w = 800) =>
    `https://images.unsplash.com/photo-${id}?auto=format&w=${w}&q=80`;

const SECTORS = [
    { id: "kafe", label: "Kafe & Restoran", img: u("1507914464562-6ff4ac29692f"), alt: "Kahve hazırlayan barista" },
    { id: "fitness", label: "Fitness & Spor", img: u("1637430308606-86576d8fef3c"), alt: "Karanlık tonlarda fitness salonu" },
    { id: "guzellik", label: "Güzellik & Bakım", img: u("1731514771613-991a02407132"), alt: "Cilt bakımı uygulaması" },
    { id: "klinik", label: "Klinik & Sağlık", img: u("1728342057953-94bfad8f0e7e"), alt: "Modern klinik içi" },
    { id: "perakende", label: "Perakende & Butik", img: u("1441984904996-e0b6ba687e04"), alt: "Butik mağaza içi" },
    { id: "bakim", label: "Kişisel Bakım", img: u("1503951914875-452162b0f3f1"), alt: "Berber koltuğunda müşteri" },
];

export default function Sectors() {
    return (
        <section data-testid="sectors-grid-section" className="bg-coal py-24 md:py-32">
            <div className="mx-auto w-full max-w-[1240px] px-6 md:px-10">
                <Reveal>
                    <Eyebrow>Sektörler</Eyebrow>
                    <h2 className="mt-5 max-w-2xl font-display text-4xl leading-tight text-cream sm:text-5xl lg:text-6xl">
                        Farklı sektörler. Aynı netlik.
                    </h2>
                </Reveal>

                <div className="mt-14 grid grid-cols-2 gap-3 md:gap-4 lg:grid-cols-3">
                    {SECTORS.map((s, i) => (
                        <Reveal key={s.id} delay={(i % 3) * 0.08}>
                            <figure
                                data-testid={`sector-item-${s.id}`}
                                className="group relative aspect-[4/5] overflow-hidden bg-charcoal"
                            >
                                <img
                                    src={s.img}
                                    alt={s.alt}
                                    loading="lazy"
                                    decoding="async"
                                    className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                                />
                                <figcaption className="absolute bottom-3 left-3 bg-ink/70 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-cream backdrop-blur-sm md:bottom-4 md:left-4">
                                    {s.label}
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
